import { useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import { Navigate } from "react-router-dom";
import {
  fetchInit,
  fetchStatus,
  updateStatus,
  updateUserName,
} from "../actions/userActions";
import PropTypes from "prop-types";

const LoginGuard = ({ children }) => {
  const userId = localStorage.getItem("userId");
  const userName = localStorage.getItem("userName");
  const initData = useSelector((state) => state.user.initData);
  const statusData = useSelector((state) => state.user.statusData);
  const dispatch = useDispatch();

  useEffect(() => {
    if (userId) {
      dispatch(fetchInit(userId, 2));
      dispatch(updateUserName(userName));
    }
  }, []);

  useEffect(() => {
    if (initData) {
      dispatch(fetchStatus(userId));
      localStorage.setItem("userName", initData.user_name);
      dispatch(updateUserName(initData.user_name));
    }
  }, [initData]);

  useEffect(() => {
    // 若bear_set無資料，設定初始值
    if (statusData?.bear_set === null) {
      dispatch(
        updateStatus({
          user_no: userId,
          user_name: userName,
          bear_set: [
            {
              categoryId: 1,
              isLock: true,
              equipment: [],
            },
            {
              categoryId: 2,
              isLock: true,
              equipment: [],
            },
            {
              categoryId: 3,
              isLock: true,
              equipment: [],
            },
            {
              categoryId: 4,
              isLock: true,
              equipment: [],
            },
            {
              categoryId: 5,
              isLock: true,
              equipment: [],
            },
            {
              categoryId: 6,
              isLock: true,
              equipment: [],
            },
            {
              categoryId: 7,
              isLock: true,
              equipment: [],
            },
          ],
        }),
      );
    }
  }, [statusData]);

  if (!userId) {
    return <Navigate to="/login" replace />;
  }

  if (!statusData) {
    return <div>Loading...</div>;
  }

  return children;
};

LoginGuard.propTypes = {
  children: PropTypes.node.isRequired,
};

export default LoginGuard;
